import React from "react"
import { Typography, typographyTypes } from "../../shared/components/Typography"

interface SubsectionContentProps {
  title?: string
}

interface SubsectionContentListProps {
  listItems: (string | React.ReactNode)[]
  listItemsStyles?: string
}

export const SubsectionContent: React.FC<
  React.PropsWithChildren<SubsectionContentProps>
> = ({ children, title }) => {
  return (
    <div className="flex flex-col gap-2">
      {title && (
        <Typography
          text={title}
          variant={typographyTypes.PANEL_SUBTITLE}
          styleOverrides="text-gray-900"
        />
      )}
      <div>{children}</div>
    </div>
  )
}

export const SubsectionContentList: React.FC<SubsectionContentListProps> = ({
  listItems,
  listItemsStyles,
}) => {
  return (
    <ul
      className={`list-none p-0 m-0 ${listItemsStyles ? listItemsStyles : ""}`}
    >
      {listItems.map((listItem, index) => (
        <li key={index}>
          <Typography text={listItem} variant={typographyTypes.NORMAL} />
        </li>
      ))}
    </ul>
  )
}
